import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {ObjectBaseComponent} from "../../../../../core/shared/object/mvs-object-base/object-base.component";


@Component({
    selector: 'ea-analysis-object-component',
    templateUrl: 'ea-analysis-object.component.html',
    standalone: false
})
export class EaAnalysisObjectComponent extends ObjectBaseComponent implements OnInit, OnChanges, OnDestroy {

    onObjectChanged() {
        const dto = this.dto as any;
        if (dto?.sourceFile?.originalFileName) {
            this.setPageTitle(`Analysis: ${dto.sourceFile.originalFileName}`);
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (!this.initialized) {
            return;
        }
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }
}
